import { Lightning } from '@lightningjs/sdk';
import _merge from 'lodash/merge';
import { defaultContext, getInitialStyle, INCENTIVE_PADDING } from './pill.style';

export default class Pill extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _init() {
    const label = this.tag('Label');

    const handleUpdate = () => {
      const incentiveWidth = label.finalW + INCENTIVE_PADDING[this._style.screenSize] * 2;
      const labelOffsetX = (incentiveWidth - label.finalW) / 2;

      this.patch({
        w: incentiveWidth,
        Label: {
          x: labelOffsetX,
        },
      });
    };

    label.on('txLoaded', handleUpdate);
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  set backgroundColor(value) {
    this.tag('Background').color = value;
  }
}
